import { render } from "./recovery_form.vue?vue&type=template&id=9758273c"
import script from "./recovery_form.js?vue&type=script&lang=js"
export * from "./recovery_form.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__